import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import EntityForm from "../components/EntityForm";
import { createRoom } from "../api/coreApi";
import { fkId } from "../utils/coreHelpers";

export default function RoomFormStep({
  loading,
  setLoading,
  setErr,
  refreshAll,
  goNext,
  wards = [],
  selectedWardId,
  setSelectedWardId,
  setSelectedRoomId,
}) {
  if (!wards.length) return <Alert severity="warning">Create Ward first (Step 2).</Alert>;

  const wardOptions = wards.map((w) => ({
    value: fkId(w.ward_id || w.id),
    label: `${w.name} (${w.ward_type || "-"})`,
  }));

  const onSubmit = async (vals, helpers) => {
    setLoading(true);
    setErr("");

    try {
      const payload = {
        ward: selectedWardId,
        room_label: vals.room_label,
        room_type: vals.room_type,
      };

      const res = await createRoom(payload);
      const newRoomId = fkId(res?.data?.room_id || res?.data?.id);
      if (newRoomId) setSelectedRoomId(newRoomId);

      goNext();
      await refreshAll();
      helpers?.reset?.();
    } catch (e) {
      setErr(e?.response?.data ? JSON.stringify(e.response.data) : "Create room failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: 900, mb: 1 }}>Step 3: Room</Typography>

      <EntityForm
        title="Create Room"
        loading={loading}
        initialValues={{
          _ward: selectedWardId || wardOptions[0]?.value || "",
          room_label: "",
          room_type: "",
        }}
        fields={[
          {
            name: "_ward",
            label: "Ward",
            type: "select",
            required: true,
            options: wardOptions,
          },
          { name: "room_label", label: "Room Label", required: true, placeholder: "101 / A1" },
          { name: "room_type", label: "Room Type (optional)", placeholder: "Private / Shared" },
        ]}
        onSubmit={(vals, helpers) => {
          if (vals._ward && vals._ward !== selectedWardId) {
            setSelectedWardId(vals._ward);
          }
          return onSubmit(vals, helpers);
        }}
      />
    </Box>
  );
}